import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cancel",
  "use": "cancel-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"cancel\"><path d=\"M8.813 0L5 3.813 1.187 0 0 1.187 3.813 5 0 8.813 1.187 10 5 6.187 8.813 10 10 8.813 6.187 5 10 1.187z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/cancel.svg
// module id = 96
// module chunks = 0